import { Component, Inject,Input} from '@angular/core';
import {_} from '../../../js/globals';

@Component({
    standalone: false,
    selector: 'incomplete-setup-mixin',
    templateUrl: '../app/content-components/incomplete-setup-mixin/incomplete-setup-mixin.view.html',
    styleUrls: ['../app/content-components/incomplete-setup-mixin/incomplete-setup-mixin.style.css']
})
export class IncompleteSetupMixinComponent {
  
   
    @Input() incompleteSetupMessage: string = '';

    _:any;
  
    constructor(@Inject('MySynchFactory') private MSF:any) {
        this._ = _;
    }

    

    setupIsIncomplete(){
        return this.incompleteSetupMessage !== '';
    }

    getIncompleteSetupMessages(){
        return this.incompleteSetupMessage.split('|');
    }

    getTerritoryManager(){
        return this.MSF.getActiveFarmTerritoryManager();
    }
}